//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	name: 'CreditPackageDialog',

	data() {
		return {
			error: null,
			loading: false,
			showError: false,
			selectedPackage: null,
		};
	},

	computed: {
		tokenPackages() {
			return this.$store.getters['tokenPackages/getPackages'];
		},
	},

	created() {
		this.getCreditPackages();
	},

	methods: {
		getCreditPackages() {
			this.$store.dispatch('tokenPackages/getPackages');
		},

		async purchase() {
			if (!this.selectedPackage) {
				this.showError = true;

				return;
			}

			this.loading = true;

			await this.$store
				.dispatch('invoices/createInvoice', {
					job_token_package_uuid: this.selectedPackage,
				})
				.then((res) => {
					window.open(res.url, '_blank').focus();
					this.$emit('close-modal');
				})
				.catch((err) => {
					this.error = err.response.data.message;
				});

			this.loading = false;
		},
	},
};
